import React from 'react'
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch'

const CustomizedSwitch = styled(Switch)({
  '& .MuiSwitch-switchBase': {
    color: 'rgb(229, 229, 229)',
    '&.Mui-checked': {
      color: 'rgb(234, 93, 13)',
    },
    '&.Mui-checked + .MuiSwitch-track': {
      backgroundColor: 'rgb(234, 93, 13)',
    },
  },
})

export default function CustomSwitch(props) {
  return (
    <div
      style={{
        fontSize: props.fontSize ? props.fontSize : '18px',
      }}
    >
      <CustomizedSwitch
        checked={props.checked}
        onChange={props.onHandleChange}
        name='checked'
        tabIndex={props.tabIndex}
      />
      <span style={{ verticalAlign: 'middle' }}>{props.text}</span>
    </div>
  )
}
